import { InfoOutlined } from 'components/icons';
import { FormattedMessage } from 'react-intl';
import { InvoiceData } from 'types/invoices';
import { cn } from 'utils/cn';
import { useSharedPayment } from './useSharedPayment';

/**
 * Under the totals of an invoice that several payers share before its split: the VAT shown is the main payer's, as
 * the other payers' VAT exists only on their own invoices once the split has run.
 */
export function MainPayerVatNote({ invoice, className }: { invoice: InvoiceData; className?: string }) {
    const { hasMultiplePayers } = useSharedPayment(invoice);
    if (!hasMultiplePayers) {
        return null;
    }
    return (
        <p className={cn('text-caption text-fg-secondary flex items-start gap-1.5', className)}>
            <InfoOutlined className="mt-0.5 size-4 shrink-0" />
            <FormattedMessage
                id="invoices.payers.vat-of-main-payer-note"
                values={{ name: invoice.clientParty?.name }}
            />
        </p>
    );
}
